import { Col, Row } from 'antd'
import ChatCard from './chat/ChatCard'
import React from 'react'
import SubmissionCard from './components/SubmissionCard'
import { useDocumentTitle } from '../../../../../hooks/useDocumentTitle'
import { useRefinementInitialization } from '../../../../../hooks/useRefinementInitialization'
import usePeriodicRefinementNextItem from '../../../../../hooks/usePeriodicRefinementNextItem'

const RubricRefinementSection = () => {
    useDocumentTitle('Rubric Refinement')
    usePeriodicRefinementNextItem()
    const { isLoading } = useRefinementInitialization()

    return (
        <Row gutter={[16, 16]}>
            <Col span={14}>
                <ChatCard />
            </Col>
            <Col span={10}>
                <SubmissionCard isLoading={isLoading}/>
            </Col>
        </Row>
    )
}

export default RubricRefinementSection
